module.exports = __webpack_public_path__ + "static/media/icon-fullscreen.532de09e.svg";